import React from 'react';

interface IProps {
  options: { label: string; value: string }[];
  name?: string;
  id?: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  error?: string;
  disabled?: boolean;
  readOnly?: boolean;
}
const CustomRadio = (props: IProps) => {
  const [inputValue, setInputValue] = React.useState<string>(props.value ?? '');

  React.useEffect(() => {
    if (props.value) {
      setInputValue(props.value);
    } else {
      setInputValue('');
    }
  }, [props.value]);

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    props.onChange?.(e);
  };

  return (
    <>
      <div className={`custom-radio ${props.className || ''}`} style={props.style}>
        {props.label ? <span className={'group-label'}>{props.label}</span> : null}
        <div className={'radio-group'}>
          {props.options.map((opt, index) => (
            <label key={index} htmlFor={`${props.id}-${index}`}>
              <input
                id={`${props.id}-${index}`}
                name={props.name}
                type="radio"
                value={opt.value}
                checked={inputValue === opt.value}
                onChange={handleOnchange}
                disabled={props.disabled}
                readOnly={props.readOnly}
              />
              {opt.label}
            </label>
          ))}
        </div>

        {props.error && <div className="error-text">{props.error}</div>}
      </div>
    </>
  );
};

export default CustomRadio;
